import {HttpErrorResponse} from '@angular/common/http';

export class HttpErrorConverter {
  static convertToString(errorResult: HttpErrorResponse): string {
    if (Array.isArray(errorResult.error)) {
      return this.handleArrayErrors(errorResult);
    } else if (typeof errorResult.error === 'string') {
      return this.handleStringErrors(errorResult);
    } else {
      return this.handleErrors(errorResult);
    }
  }

  private static handleArrayErrors(errorResult: HttpErrorResponse) {
    return errorResult.error.join(', ');
  }

  private static handleStringErrors(errorResult: HttpErrorResponse) {
    return errorResult.error;
  }

  private static handleErrors(errorResult: HttpErrorResponse) {
    return errorResult.message;
  }
}
